module.exports = __webpack_public_path__ + "img/ticket.20610307.svg";